import React from 'react';
import {
  Button,
  Modal,
  Spinner,
} from 'react-bootstrap';
import { FaBan } from 'react-icons/fa';

export default function ModalRemoverFila(props) {
  var show = props.show;
  var onHide = props.onHide;
  var item = props.item;
  var isRemovendo = props.isRemovendo;
  var onConfirmar = props.onConfirmar;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton className="bg-danger text-white">
        <Modal.Title>Tirar da Fila</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {item && (
          <p>
            Deseja realmente tirar o prospecto{' '}
            <strong>{item.nome || item.codigo}</strong> da fila
            do ativo <strong>QD {item.mapa1} / LT {item.mapa2}</strong>?
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={isRemovendo}
        >
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={onConfirmar}
          disabled={isRemovendo}
        >
          {isRemovendo ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            <>
              <FaBan className="mr-1" />
              Confirmar
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
